export const TenderData = [
  {
      "key": "T83",
      "eventName": "tenders",
      "date": "24 September 2026",
      "expiryDate": "25 September 2026",
      "name": "Pre-Bid Notice for RFP for Supply of Sports Science Equipment for Bihar State Sports Authority",
      "corrigendum": "",
      "url": "https://biharsports.org/pdf/notices/pre-bid-notice-related-to-rfp-for-supply-of-sports-science-equipment-for-bihar-state-sports-authority.pdf"
    },
  {
      "key": "T82",
      "eventName": "tenders",
      "date": "09 September 2026",
      "expiryDate": "08 October 2026",
      "name": "RFP FOR SUPPLY OF SPORTS SCIENCE EQUIPMENT FOR BIHAR STATE SPORTS AUTHORITY (RFP No. BSSA/Tender/Sports Science/26-27/Phase-1/4125 (PR NO. 011321 (B&C) 2026-27))",
      "corrigendum": "",
      "url": "https://biharsports.org/pdf/notices/BSSA-SPORTS-SCIENCE-TENDER-FULL-DETAILS-PHASE-01.pdf"
    },
  {
      "key": "T81",
      "eventName": "tenders",
      "date": "17 August 2026",
      "expiryDate": "17 August 2026",
      "name": "Tender Cancellation Notice - RFP FOR SUPPLY OF SPORTS SCIENCE  RFP No.: BSSA/Tender/25-26/3359/26",
      "corrigendum": "",
      "url": "https://biharsports.org/pdf/notices/sports-science-tender-cancel.pdf"
    },
  {
      "key": "T80",
      "eventName": "tenders",
      "date": "6 August 2026",
      "expiryDate": "17 August 2026",
      "name": "PRE BID NOTICE FOR BIHAR STATE SPORTS AUTHORITY RFP No.: BSSA/Tender/25-26/3359/26",
      "corrigendum": "",
      "url": "https://biharsports.org/pdf/notices/L.No-3643.pdf"
    },
  {
      "key": "T79",
      "eventName": "tenders",
      "date": "14 July 2026",
      "expiryDate": "17 August 2026",
      "name": "RFP FOR SUPPLY OF SPORTS SCIENCE EQUIPMENT FOR BIHAR STATE SPORTS AUTHORITY RFP No.: BSSA/Tender/25-26/3359/26",
      "corrigendum": "",
      "url": "https://biharsports.org/pdf/notices/sports-science-tender-full-details.pdf"
    },
  {
      "key": "T78",
      "eventName": "tenders",
      "date": "10 June 2026",
      "expiryDate": "",
      "name": "TENDER CANCELLATION NOTICE FOR ENGAGEMENT OF CATERING AGENCY AT STATE SPORTS ACADEMY, RAJGIR FOR THE PERIOD OF 02 YEARS  RFP No.: SSA/Tender/26-27/Catering /212 (PR No. 002195 (B&C) 26-27",
      "corrigendum": "",
      "url": "https://biharsports.org/pdf/notices/Canceletion-Mess-Tendar.pdf"
    },
  {
      "key": "T77",
      "eventName": "tenders",
      "date": "8 June 2026",
      "expiryDate": "15 June 2026",
      "name": "TENDER SUBMITTION DATE EXTEND NOTICE FOR ENGAGEMENT OF CATERING AGENCY AT STATE SPORTS ACADEMY, RAJGIR FOR THE PERIOD OF 02 YEARS (REF NO:-SSA/TENDER/26-27/CATERING/212) (PR No. 002195 (B&C) 2026-27)",
      "corrigendum": "",
      // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
      "url": "https://biharsports.org/pdf/notices/Notices.pdf"
    },
  {
      "key": "T76",
      "eventName": "tenders",
      "date": "26 May 2026",
      "expiryDate": "",
      "name": "CORRIGENDUM - 01 ENGAGEMENT OF CATERING AGENCY AT STATE SPORTS ACADEMY, RAJGIR FOR THE PERIOD OF 02 YEARS,  RFP No.: SSA/Tender/26-27/Catering/212 (PR NO.002195 (B&C) 2026-27",
      "corrigendum": "",
      // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
      "url": "https://biharsports.org/pdf/notices/Corrigendum-01.pdf"
    },
  {
      "key": "T75",
      "eventName": "tenders",
      "date": "13 May 2026",
      "expiryDate": "20 May 2026",
      "name": "Information regarding the list of successful/unsuccessful firms in the technical bid and the opening of the financial bid related to the tender “SUPPLY, INSTALLATION, TESTING & COMMISSIONING OF FIREWALL FOR BIHAR STATE SPORTS AUTHORITY”, RFP No. BSSA/Tender/25-26/Firewall/1/1992 (PR. No. 000813 (B&C) 2026-27), published by Bihar State Sports Authority, Patna",
      "corrigendum": "",
      // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
      "url": "https://biharsports.org/pdf/notices/notice-for-financial-bid-opening.pdf"
    }, 
  {
      "key": "T74",
      "eventName": "tenders",
      "date": "07 May 2026",
      "expiryDate": "11 May 2026",
      "name": "CORRIGENDUM - 01 SUPPLY, INSTALLATION, TESTING & COMMISSIONING OF FIREWALL FOR BIHAR STATE SPORTS AUTHORITY, RFP No.: BSSA/Tender/25-26/Firewall/1/1992 (PR NO. 000813 (B&C) 2026-27",
      "corrigendum": "",
      // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
      "url": "https://biharsports.org/pdf/notices/fyrewall.pdf"
    }, 
  {
      "key": "T73",
      "eventName": "tenders",
      "date": "30 April 2026",
      "expiryDate": "8 June 2026",
      "name": "ENGAGEMENT OF CATERING AGENCY AT STATE SPORTS ACADEMY, RAJGIR FOR THE PERIOD OF 02 YEARS,  RFP No.: SSA/Tender/26-27/Catering/212 (PR NO.002195 (B&C) 2026-27",
      "corrigendum": "",
      // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
      "url": "https://biharsports.org/pdf/notices/RFPforMESSFullPDF.pdf"
    }, 
  {
      "key": "T72",
      "eventName": "tenders",
      "date": "30 April 2026",
      "expiryDate": "8 May 2026",
      "name": "Financial Bid Opening Notice For RFP No. BSSA,Short Tender,24-25, Electrical Item, 1710 (PR No. 27143 B&C) 2025-26.pdf",
      "corrigendum": "",
      // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
      "url": "https://biharsports.org/pdf/notices/electrycal.pdf"
    }, 
    {
      "key": "T71",
      "eventName": "tenders",
      "date": "30 April 2026",
      "expiryDate": "8 May 2026",
      "name": "Financial Bid Opening Notice For RFP No. BSSA,Short Tender,25-26, Furniture Item, 1739 (PR No. 27162 B&C) 2025-26.pdf",
      "corrigendum": "",
      // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
      "url": "https://biharsports.org/pdf/notices/furnyture.pdf"
    }, 
    {
      "key": "T70",
      "eventName": "tenders",
      "date": "15 April 2026",
      "expiryDate": "17 April 2026",
      "name": "CORRIGENDUM - 02 - ESTABLISHMENT OF RATE CONTRACT FOR BIHAR STATE SPORTS AUTHORITY FOR A PERIOD OF 03 YEARS FOR ELECTRICAL ITEMS",
      "corrigendum": "",
      // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
      "url": "https://biharsports.org/pdf/notices/electrical.pdf"
    }, 
  {
      "key": "T69",
      "eventName": "tenders",
      "date": "15 April 2026",
      "expiryDate": "17 April 2026",
      "name": "CORRIGENDUM - 02 - ESTABLISHMENT OF RATE CONTRACT FOR BIHAR STATE SPORTS AUTHORITY FOR A PERIOD OF 03 YEARS FOR FURNITURE ITEMS",
      "corrigendum": "",
      // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
      "url": "https://biharsports.org/pdf/notices/furniture.pdf"
    }, 
  {
      "key": "T68",
      "eventName": "tenders",
      "date": "14 April 2026",
      "expiryDate": "08 May 2026",
      "name": "RFP FOR SUPPLY, INSTALLATION, TESTING & COMMISSIONING OF FIREWALL FOR BIHAR STATE SPORTS AUTHORITY",
      "corrigendum": "",
      // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
      "url": "https://biharsports.org/pdf/notices/firewall.pdf"
    }, 
  {
      "key": "T67",
      "eventName": "tenders",
      "date": "10 April 2026",
      "expiryDate": "15 April 2026",
      "name": "CORRIGENDUM - 01 - ESTABLISHMENT OF RATE CONTRACT FOR BIHAR STATE SPORTS AUTHORITY FOR A PERIOD OF 03 YEARS FOR ELECTRICAL ITEMS",
      "corrigendum": "",
      // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
      "url": "https://biharsports.org/pdf/notices/letter-no-1990.pdf"
    }, 
  {
      "key": "T66",
      "eventName": "tenders",
      "date": "10 April 2026",
      "expiryDate": "15 April 2026",
      "name": "CORRIGENDUM - 01 - ESTABLISHMENT OF RATE CONTRACT FOR BIHAR STATE SPORTS AUTHORITY FOR A PERIOD OF 03 YEARS FOR FURNITURE ITEMS",
      "corrigendum": "",
      // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
      "url": "https://biharsports.org/pdf/notices/letter-no-1991.pdf"
    }, 
    {
      "key": "T65",
      "eventName": "tenders",
      "date": "1 April 2026",
      "expiryDate": "",
      "name": "List of firms shortlisted for RFP No. BSSA/Tender/25-26/EMA-01/6350 PR No. 019456 (B&C) 25-26, pertaining to the empanelment of agencies for Event Management and Operations for the Bihar State Sports Authority for a period of 03 (three) years.",
      "corrigendum": "",
      // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
      "url": "https://biharsports.org/pdf/notices/listOfEmanelledAgenciesOfBiharStateSportsAuthority.pdf"
    },
  {
      "key": "T64",
      "eventName": "tenders",
      "date": "24 March 2026",
      "expiryDate": "10 April 2026",
      "name": "ESTABLISHMENT OF RATE CONTRACT FOR BIHAR STATE SPORTS AUTHORITY FOR A PERIOD OF 03 YEARS FOR FURNITURE ITEMS",
      "corrigendum": "",
      // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
      "url": "https://biharsports.org/pdf/notices/BSSA-SHORT-TENDER-FOR-FURNITURE-ITEM-PDF.pdf"
    }, 
  {
      "key": "T63",
      "eventName": "tenders",
      "date": "23 March 2026",
      "expiryDate": "10 April 2026",
      "name": "ESTABLISHMENT OF RATE CONTRACT FOR BIHAR STATE SPORTS AUTHORITY FOR A PERIOD OF 03 YEARS FOR ELECTRICAL ITEMS",
      "corrigendum": "",
      // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
      "url": "https://biharsports.org/pdf/notices/134187299269238739.pdf"
    }, 
  {
      "key": "T62",
      "eventName": "tenders",
      "date": "20 February 2026",
      "expiryDate": "16 March 2026",
      "name": "ENGAGAMENT OF SECURITY AGENCY FOR PROVIDING WATCH AND WARD SECURITY SUPERVISOR AND SECURITY GUARD AT THE STATE SPORTS ACADEMY, RAJGIR FOR A PERIOD OF 03 YEARS, RFP No. SSA/Tender/25-26/Security- RSC/170 (2nd Call) PR No. 015453 (B&C)",
      "corrigendum": "",
      // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
      "url": "https://biharsports.org/pdf/notices/corrigendum-for-ssa-Tender.pdf"
    }, 
  {
      "key": "T61",
      "eventName": "tenders",
      "date": "23 February 2026",
      "expiryDate": "",
      "name": "List of finally successful and unsuccessful firms after evaluation of technical documents and technical presentation for the tender regarding the empanelment of agencies for event management and operations for the Bihar State Sports Authority (BSSA) for a period of 03 (three) years, RFP No. BSSA/Tender/25-26/EMA-01/6350, PR No. 019456 (B&C) 25-26",
      "corrigendum": "",
      // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
      "url": "https://biharsports.org/pdf/notices/accepted-tenders.pdf"
    }, 
  {
      "key": "T60",
      "eventName": "tenders",
      "date": "20 February 2026",
      "expiryDate": "27 February 2026",
      "name": "Request for quotation regarding the purchase of sports equipment under the Saksham Yojana for Khushi Kumari",
      "corrigendum": "",
      // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
      "url": "https://biharsports.org/pdf/notices/khushi-kumari-quation-weightlifting.pdf"
    },
   {
      "key": "T59",
      "eventName": "tenders",
      "date": "20 February 2026",
      "expiryDate": "27 February 2026",
      "name": "Request for quotation for wrestling sports equipment for the Eklavya Centre.",
      "corrigendum": "",
      // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
      "url": "https://biharsports.org/pdf/notices/kushti-quation.pdf"
    },
  //  {
  //     "key": "T58",
  //     "eventName": "tenders",
  //     "date": "20 February 2026",
  //     "expiryDate": "27 February 2026",
  //     "name": "Request for quotation for purchase of equipment for the Ekalavya Centre – Weightlifting discipline.",
  //     "corrigendum": "",
  //     // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
  //     "url": "https://biharsports.org/pdf/notices/weighlifting-quation.pdf"
  //   },
   {
      "key": "T57",
      "eventName": "tenders",
      "date": "11 February 2026",
      "expiryDate": "",
      "name": "REJECTION LIST OFF THE BIDDERS FOR THE WORK  EMPANELMENT OF AGENCIES FOR EVENT MANAGEMENT AND OPERATIONS FOR BIHAR STATE SPORTS AUTHORITY FOR A PERIOD OF 03 YEARS RFP No.: BSSA/Tender/25-26/EMA -01/6350  PR No. 019456 (B&C) 25-26",
      "corrigendum": "",
      // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
      "url": "https://biharsports.org/pdf/notices/rejected-tenders.pdf"
    },
 {
    "key": "T56",
    "eventName": "tenders",
    "date": "19 February 2026",
    "expiryDate": "26 February 2026",
    "name": "Request for Quotation for Purchase of Sports Equipment for Akash Kumar under the Saksham Scholarship Scheme",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "https://biharsports.org/pdf/notices/akash-kushti.pdf"
  },
 {
    "key": "T55",
    "eventName": "tenders",
    "date": "18 February 2026",
    "expiryDate": "23 February 2026",
    "name": "Regarding the invitation of quotations for the purchase of Kabaddi sports equipment for Eklavya Training Centres in Buxar, Begusarai, and Sitamarhi",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "https://biharsports.org/img/notices/1lavya-kabaddi-tender1.jpeg"
  },
 {
    "key": "T54",
    "eventName": "tenders",
    "date": "10 February 2026",
    "expiryDate": "27 February 2026",
    "name": "Appointment of a Security Agency for Providing Surveillance & Security Supervisors and Security Guards at the State Sports Academy, Rajgir for a Period of Three (03) Years. RFP No.: SSA/Tender/25-26/Security/170/2nd Call (PR No. 023748 (B&C) 2025-26)",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "https://biharsports.org/pdf/notices/security-2nd-call.pdf"
  },
 {
    "key": "T53",
    "eventName": "tenders",
    "date": "11 February 2026",
    "expiryDate": "16 February 2026",
    "name": "Request for quotation regarding the purchase of sports equipment under the Saksham Scholarship Scheme",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "https://biharsports.org/pdf/notices/saksham.pdf"
  },
 {
    "key": "T52",
    "eventName": "tenders",
    "date": "9 February 2026",
    "expiryDate": "12 February 2026",
    "name": "Request for quotation for the purchase of one large movable goalpost and one small goalpost for practice purposes of the players of Khelo India Small Centre, Football, Jamui.",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "https://biharsports.org/pdf/notices/jamui-football.pdf"
  },
 {
    "key": "T51",
    "eventName": "tenders",
    "date": "6 February 2026",
    "expiryDate": "9 February 2026",
    "name": "Request for Quotation regarding the purchase of sports equipment for Eklavya Taekwondo Training Centre, Begusarai",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "https://biharsports.org/pdf/notices/1lavya-taekwando.pdf"
  },
 {
    "key": "T50",
    "eventName": "tenders",
    "date": "5 February 2026",
    "expiryDate": "10 February 2026",
    "name": "Regarding the invitation of quotations for the purchase and supply of sports equipment for the trainees at Eklavya State Residential Archery Sports Training Center",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "https://biharsports.org/img/notices/1lavya-archery-2.jpeg"
  },
 {
    "key": "T49",
    "eventName": "tenders",
    "date": "5 February 2026",
    "expiryDate": "10 February 2026",
    "name": "Invitation of quotations for the purchase and supply of sports equipment for players training at the Eklavya State Residential Archery Training Centre",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "https://biharsports.org/img/notices/1lavya-archery-1.jpeg"
  },
 {
    "key": "T48",
    "eventName": "tenders",
    "date": "2 February 2026",
    "expiryDate": "5 February 2026",
    "name": "Request for quotations for the purchase of sports equipment for football at Eklavya Training Center.",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "https://biharsports.org/pdf/notices/1lavya-football-quotation.pdf"
  },
 {
    "key": "T47",
    "eventName": "tenders",
    "date": "20 January 2026",
    "expiryDate": "2 February 2026",
    "name": "Request for quotation for the purchase of sports kits and equipment for Eklavya Training Centre, football.",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "https://biharsports.org/pdf/notices/1lavya-football-tender.pdf"
  },
 {
    "key": "T46",
    "eventName": "tenders",
    "date": "22 January 2026",
    "expiryDate": "27 January 2026",
    "name": "Invitation of quotations for the procurement of Kabaddi sports equipment for Eklavya Kabaddi Training Centres in Buxar and Sitamarh",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "https://biharsports.org/img/notices/1lavya-kabaddi-tender.jpeg"
  },
 {
    "key": "T45",
    "eventName": "tenders",
    "date": "13 January 2026",
    "expiryDate": "20 January 2026",
    "name": "Request for provision of quotations for sports equipment related to the Eklavya State Residential Training Center, Archery Sports Discipline.",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "https://biharsports.org/pdf/notices/Quotation Demand for Archery Eklavya.pdf"
  },
 {
    "key": "T44",
    "eventName": "tenders",
    "date": "13 January 2026",
    "expiryDate": "15 January 2026",
    "name": "Request for quotation for purchase of boxing sports equipment/kits.",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "https://biharsports.org/img/notices/boxing-equipments.jpeg"
  },
 {
    "key": "T43",
    "eventName": "tenders",
    "date": "7 January 2026",
    "expiryDate": "8 January 2026",
    "name": "Request for quotations for the purchase of sports equipment and sports materials for the Para Athletics sports discipline.",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "https://biharsports.org/pdf/notices/para-athletics.pdf"
  },
 {
    "key": "T42",
    "eventName": "tenders",
    "date": "7 January 2026",
    "expiryDate": "19 January 2026",
    "name": "Corrigendum – 01 - EMPANELMENT OF AGENCIES FOR EVENT MANAGEMENT AND OPERATIONS FOR BIHAR STATE SPORTS AUTHORITY FOR A PERIOD OF 03 YEARS (RFP No.: BSSA/Tender/25-26/EMA -01/6350  PR No. 019456 (B&C) 25-26)",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "https://biharsports.org/pdf/notices/ACE Scanner_2026_01_07.pdf"
  },
 {
    "key": "T41",
    "eventName": "tenders",
    "date": "23 December 2025",
    "expiryDate": "27 December 2026",
    "name": "Regarding the request for quotation for the purchase of football sports equipment.",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "https://biharsports.org/pdf/notices/DOC-20251224-WA0003..pdf"
  },
 {
    "key": "T40",
    "eventName": "tenders",
    "date": "24 December 2025",
    "expiryDate": "26 December 2026",
    "name": "Regarding the request for quotation for the purchase of badminton sports equipment.",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "https://biharsports.org/img/notices/badminton-tender-26-12-2025.jpeg"
  },
 {
    "key": "T39",
    "eventName": "tenders",
    "date": "11 December 2025",
    "expiryDate": "13 January 2026",
    "name": "EMPANELMENT OF AGENCIES FOR EVENT MANAGEMENT AND OPERATIONS FOR BIHAR STATE SPORTS AUTHORITY FOR A PERIOD OF 03 YEARS.",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "https://biharsports.org/pdf/notices/BSSA-EMA-TENDER-FULL-DETAILS-PDF.pdf"
  },
 {
    "key": "T39",
    "eventName": "tenders",
    "date": "11 December 2025",
    "expiryDate": "13 January 2026",
    "name": "EMPANELMENT OF AGENCIES FOR EVENT MANAGEMENT AND OPERATIONS FOR BIHAR STATE SPORTS AUTHORITY FOR A PERIOD OF 03 YEARS.",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "https://biharsports.org/pdf/notices/BSSA-EMA-TENDER-FULL-DETAILS-PDF.pdf"
  },
 {
    "key": "T38",
    "eventName": "tenders",
    "date": "13 November 2025",
    "expiryDate": "4 November 2025",
    "name": "CORRIGENDUM - 02 - COMPREHENSIVE HOUSEKEEPING, MAINTENANCE AND OPERATIONS FOR STADIUMS, OFFICES, HOSTELS, HORTICULTURE AND OTHER ALLIED FACILITIES AT THE STATE SPORTS ACADEMY, RAJGIR FOR A PERIOD OF 03 YEARS RFP No.: SSA/Tender/25-26/O&M/171  (PR No. 015463 (B & C) 2025-26))",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "https://biharsports.org/pdf/notices/Scanned_20251107_155619.pdf"
  },
 {
    "key": "T37",
    "eventName": "tenders",
    "date": "13 November 2025",
    "expiryDate": "3 November 2025",
    "name": "COMPREHENSIVE HOUSEKEEPING, MAINTENANCE AND OPERATIONS FOR STADIUMS, OFFICES, HOSTELS, HORTICULTURE AND OTHER ALLIED FACILITIES AT THE STATE SPORTS ACADEMY, RAJGIR FOR A PERIOD OF 03 YEARS RFP No.: SSA/Tender/25-26/O&M/171  (PR No. 015463 (B & C) 2025-26)",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "https://biharsports.org/img/notices/images/maintain.jpg"
  },
 {
    "key": "T36",
    "eventName": "tenders",
    "date": "13 November 2025",
    "expiryDate": "3 November 2025",
    "name": "ENGAGAMENT OF SECURITY AGENCY FOR PROVIDING WATCH AND WARD SECURITY SUPERVISOR AND SECURITY GUARD AT THE STATE SPORTS ACADEMY, RAJGIR FOR A PERIOD OF 03 YEARS  RFP No.: SSA/Tender/25-26/Security/170  (PR No. 015453 (B & C) 2025-26)",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "https://biharsports.org/img/notices/images/security.jpg"
  },
 {
    "key": "T35",
    "eventName": "tenders",
    "date": "12 November 2025",
    "expiryDate": "3 November 2025",
    "name": "DESIGN, SUPPLY, INSTALLATION, TESTING, COMMISSIONING, AND MAINTENANCE OF A CAMPUS-WIDE WI-FI SOLUTION WITH COMPREHENSIVE AMC AT THE STATE SPORTS ACADEMY, RAJGIR FOR A PERIOD OF 03 YEARS  RFP No.: SSA/Tender/25-26/WIFI/179  (PR. No. 016464 (B&C) 2025-26  )",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "https://biharsports.org/img/notices/images/wifi.jpg"
  },
 {
    "key": "T34",
    "eventName": "tenders",
    "date": "24 October 2025",
    "expiryDate": "3 November 2025",
    "name": "DESIGN, SUPPLY, INSTALLATION, TESTING, COMMISSIONING, AND MAINTENANCE OF A CAMPUS-WIDE WI-FI SOLUTION WITH COMPREHENSIVE AMC AT THE STATE SPORTS ACADEMY, RAJGIR FOR A PERIOD OF 03 YEARS",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "https://biharsports.org/pdf/notices/wifi.pdf"
  },
 {
    "key": "T33",
    "eventName": "tenders",
    "date": "16 October 2025",
    "expiryDate": "3 November 2025",
    "name": "CORRIGENDUM 01 - ENGAGAMENT OF SECURITY AGENCY FOR PROVIDING WATCH AND WARD SECURITY SUPERVISOR AND SECURITY GUARD AT THE STATE SPORTS ACADEMY, RAJGIR FOR A PERIOD OF 03 YEARS (RFP No.: SSA/Tender/25-26/Security/170 (PR No. 015453 (B & C) 2025-26))",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "https://biharsports.org/pdf/notices/SECURITY.pdf"
  },
  {
    "key": "T32",
    "eventName": "tenders",
    "date": "16 October 2025",
    "expiryDate": "3 November 2025",
    "name": "CORRIGENDUM 01 - COMPREHENSIVE HOUSEKEEPING, MAINTENANCE AND OPERATIONS FOR STADIUMS, OFFICES, HOSTELS, HORTICULTURE AND OTHER ALLIED FACILITIES AT THE STATE SPORTS ACADEMY, RAJGIR FOR A PERIOD OF 03 YEARS.( SSA/Tender/25-26/0&M/171 (PR No. 015463 (B & C) 2025-26)",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "https://biharsports.org/pdf/notices/HOUSEKEEPING.pdf"
  },
  {
    "key": "T31",
    "eventName": "tenders",
    "date": "26 September 2025",
    "expiryDate": "30 October 2025",
    "name": "DESIGN, SUPPLY, INSTALLATION, TESTING, COMMISSIONING, AND MAINTENANCE OF A CAMPUS-WIDE WI-FI SOLUTION WITH COMPREHENSIVE AMC AT THE STATE SPORTS ACADEMY,RAJGIR FOR A PERIOD OF 03 YEARS",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "https://biharsports.org/pdf/notices/134033379529124522.pdf"
  },
  {
    "key": "T30",
    "eventName": "tenders",
    "date": "19 September 2025",
    "expiryDate": "20 October 2025",
    "name": "COMPREHENSIVE HOUSEKEEPING, MAINTENANCE AND OPERATIONS FOR STADIUMS, OFFICES, HOSTELS, HORTICULTURE AND OTHER ALLIED FACILITIES AT THE STATE SPORTS ACADEMY, RAJGIR FOR A PERIOD OF 03 YEARS.",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "https://biharsports.org/pdf/notices/SSA-RAJGIR-O&M-TENDER-FULL-PDF.pdf"
  },
  {
    "key": "T29",
    "eventName": "tenders",
    "date": "19 September 2025",
    "expiryDate": "17 October 2025",
    "name": " ENGAGAMENT OF SECURITY AGENCY FOR PROVIDING WATCH AND WARD SECURITY SUPERVISOR AND SECURITY GUARD AT THE STATE SPORTS ACADEMY, RAJGIR FOR A PERIOD OF 03 YEARS",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "https://biharsports.org/pdf/notices/SSA-RAJGIR-SECURITY-TENDER-FULL-PDF.pdf"
  },
  {
    "key": "T28",
    "eventName": "tenders",
    "date": "17 June 2025",
    "expiryDate": "9 July 2025",
    "name": "DESIGN, DEVELOPMENT, TESTING, COMMISSIONING, INTEGRATION AND MAINTENANCE OF ATHLETE ASSESSMENTS AND TALENT IDENTIFICATION SYSTEM AND GAMES MANAGEMENT SYSTEM AT DISTRICT AND STATE LEVEL FOR BIHAR MASHAAL 2025. (RFP: BSSA/Short Tender/25-26/GMS/3089/(2nd Call))",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "pdf/notices/GMS-SHORT-TENDER-FULL-DETAILS-PDF.pdf"
  },
  {
    "key": "T27",
    "eventName": "tenders",
    "date": "24 April 2025 ",
    "expiryDate": "",
    "name": "Corrigendum 03 regarding RFP for DESIGN, DEVELOPMENT, TESTING, COMMISSIONING, INTEGRATION AND MAINTENANCE OF ATHLETE ASSESSMENTS AND TALENT IDENTIFICATION SYSTEM AND GAMES MANAGEMENT SYSTEM AT DISTRICT AND STATE LEVEL FOR BIHAR MASHAAL 2025.",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "pdf/notices/corrigendum-3-mashaal-2025.pdf"
  },
  {
    "key": "T26",
    "eventName": "tenders",
    "date": "21 April 2025 ",
    "expiryDate": "",
    "name": "Corrigendum 02 regarding RFP for DESIGN, DEVELOPMENT, TESTING, COMMISSIONING, INTEGRATION AND MAINTENANCE OF ATHLETE ASSESSMENTS AND TALENT IDENTIFICATION SYSTEM AND GAMES MANAGEMENT SYSTEM AT DISTRICT AND STATE LEVEL FOR BIHAR MASHAAL 2025.",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "pdf/notices/Corrigendum 2. (MASHAL 2025).PDF"
  },
  {
    "key": "T25",
    "eventName": "tenders",
    "date": "18 April 2025 ",
    "expiryDate": "",
    "name": "Corrigendum regarding RFP for DESIGN, DEVELOPMENT, TESTING, COMMISSIONING, INTEGRATION AND MAINTENANCE OF ATHLETE ASSESSMENTS AND TALENT IDENTIFICATION SYSTEM AND GAMES MANAGEMENT SYSTEM AT DISTRICT AND STATE LEVEL FOR BIHAR MASHAAL 2025.",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "pdf/notices/Corrigendum. (MASHAL 2025).PDF"
  },
  {
    "key": "T25",
    "eventName": "tenders",
    "date": "4 April 2025",
    "expiryDate": "15 April 2025",
    "name": "RFP for DESIGN, DEVELOPMENT, TESTING, COMMISSIONING, INTEGRATION AND MAINTENANCE OF ATHLETE ASSESSMENTS AND TALENT IDENTIFICATION SYSTEM AND GAMES MANAGEMENT SYSTEM AT DISTRICT AND STATE LEVEL FOR BIHAR MASHAAL 2025.",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "pdf/notices/133874552464725547 (1).pdf"
  },
  {
    "key": "T24",
    "eventName": "tenders",
    "date": "24 Mar",
    "expiryDate": "",
    "name": "Corrigendum for Engagement of Overlays and Sports Operations Agency for KIYG, 2025, Bihar. RFP No. BSSA/Tender/24-25/OSOA/KIYG/1163/25.",
    "corrigendum": "",
    // "meetUrl":"https://meet.google.com/rox-xufc-wqf",
    "url": "pdf/notices/Corrigendum Related to KIYG.PDF"
  },
  {
    "key": "T23",
    "eventName": "tenders",
    "date": "Tuesday 18 Mar  •  15:00–16:00",
    "expiryDate": "",
    "name": "Pre-Bid Meeting for Engagement of Overlays and Sports Operations Agency for KIYG, 2025, Bihar. RFP No. BSSA/Tender/24-25/OSOA/KIYG/1163/25.",
    "corrigendum": "",
    "meetUrl":"https://meet.google.com/rox-xufc-wqf",
    "url": "https://meet.google.com/rox-xufc-wqf"
  },
  {
    "key": "T22",
    "eventName": "tenders",
    "date": "18.03.2025",
    "expiryDate": "07.04.2025",
    "name": "Engagement of Overlays and sport Operations Agency for Khelo India Youth Games 2025 Bihar",
    "corrigendum": "",
    // "meetUrl":"Online Meet link : https://meet.google.com/qgi-qioq-ncj",
    "url": "img/notices/133862326302838424_250314_134657.pdf"
  },
  {
    "key": "T21",
    "eventName": "tenders",
    "date": "07.02.2025 (3:00pm – 5:00pm)",
    "expiryDate": "",
    "name": "Pre bid meeting for RFP Related to ENGAGEMENT OF AGENCY FOR THE CEREMONIES OF KHELO INDIA YOUTH GAMES 2025, BIHAR - Corrigendum ",
    "corrigendum": "",
    // "meetUrl":"Online Meet link : https://meet.google.com/qgi-qioq-ncj",
    "url": "img/notices/KIYG  Cereomonies Corrigendum.PDF"
  },
  {
    "key": "T20",
    "eventName": "tenders",
    "date": "07.02.2025 (3:00pm – 5:00pm)",
    "expiryDate": "",
    "name": "Pre bid meeting for RFP Related to ENGAGEMENT OF AGENCY FOR THE CEREMONIES OF KHELO INDIA YOUTH GAMES 2025, BIHAR ",
    "corrigendum": "",
    "meetUrl":"Online Meet link : https://meet.google.com/qgi-qioq-ncj",
    "url": "https://meet.google.com/qgi-qioq-ncj"
  },
  {
    "key": "T19",
    "eventName": "tenders",
    "date": "29.01.2025",
    "expiryDate": "24.02.2025",
    "name": "RFP Related to ENGAGEMENT OF AGENCY FOR THE CEREMONIES OF KHELO INDIA YOUTH GAMES 2025, BIHAR",
    "corrigendum": "",
    "url": "img/notices/CeremoniesofKIYGGamesTender.PDF"
  },
  {
    "key": "T18",
    "eventName": "tenders",
    "date": "22.01.2025",
    "expiryDate": "-",
    "name": "Corrigendum 02 Related to Empanelment of Agencies for Supply of Sports Equipment for Bihar State Sports Authority for a Period of 03 Years (PR No. 015314 (B&C) 2024-25)",
    "corrigendum": "",
    "url": "img/notices/Corregnedum 02 Related to Sports Equipments Tender 2025.PDF"
  },
  {
    "key": "T13",
    "eventName": "tenders",
    "date": "24.12.2024",
    "expiryDate": "20.01.2025",
    "name": "Corrigendum Related to Empanelment of Agencies for Supply of Sports Equipment for Bihar State Sports Authority for a Period of 03 Years (PR No. 015314 (B&C) 2024-25)",
    "corrigendum": "",
    "url": "img/notices/SportsEquipmentsCorigendum.PDF"
  },
  {
    "key": "T12",
    "eventName": "tenders",
    "date": "24.12.2024",
    "expiryDate": "20.01.2025",
    "name": "EMPANELMENT oF AGENCIES FOR SUPPLY OF SPORTS EQUIPMENT FOR BIHAR STATE SPORTS AUTHORITY FOR A PERIOD OF 03 YEARS",
    "corrigendum": "",
    "url": "img/notices/Empanelment of Agency for Supply Sports Equipments for BSSA.pdf"
  },
  {
    "key": "T11",
    "eventName": "tenders",
    "date": "02/11/2024,",
    "expiryDate": "05/11/2024",
    "name": "Request for quotation for purchase of special equipment for practice for the players of fencing sports discipline practicing at Khelo India Small Center, Motihari",
    "corrigendum": "",
    "url": "img/notices/letterno-4309.PDF"
  },
  {
    "key": "T14",
    "eventName": "tenders",
    "date": "30/10/2024,",
    "expiryDate": "03/11/2024",
    "name": "The upcoming Bihar Women's Asian Hockey Champion Trophy 2024 Khel Vidya is to be organized from 11-20 November 2024 at Rajgir, Nalanda. Requesting Quotation for Necessary materials required for coaches accommodation, girls hostel, staff room in the aforesaid event.",
    "corrigendum": "",
    "url": "img/notices/Tender_BSSA_Letter No 4179_30.10.24.pdf"
  },
  {
    "key": "T10",
    "eventName": "tenders",
    "date": "28/10/2024,",
    "expiryDate": "01/11/2024",
    "name": "Quotation from various firms for preparing a theme song to showcase the language and culture of Bihar and to encourage the players in the organization of Bihar Women's Asian Hockey Championship Trophy 2024 (Letter No.: 4090)",
    "corrigendum": "",
    "url": ""
  },
  {
    "key": "T13",
    "eventName": "tenders",
    "date": "26/10/2024,",
    "expiryDate": "02/11/2024",
    "name": "Requesting quotation for work related to NVR with Control Room Setup, Power Cable, PVC Pipe, Patch code, Segat, Cat6 Cable, Smart TV, Hdpe Pipe, Mounting Pole, HDMI Cable, UPS, Baggage Scanner at Rajgir Sports Academy for continuous monitoring of security arrangements in the organization of Bihar Women's Asian Hockey Championship Trophy 2024.",
    "corrigendum": "",
    "url": "img/notices/Tender_BSSA_Letter No 4082_26.10.24.pdf"
  },
  {
    "key": "T12",
    "eventName": "tenders",
    "date": "25/10/2024,",
    "expiryDate": "01/11/2024",
    "name": "Requesting quotation related to installation of cameras in Rajgir Sports Academy for continuous monitoring along with security arrangements during the organization of Bihar Women's Asian Hockey Championship Trophy 2024.",
    "corrigendum": "",
    "url": "img/notices/Tender_BSSA_Letter No 4056_25.10.24.pdf"
  },
  {
    "key": "T9",
    "eventName": "tenders",
    "date": "24/10/2024,",
    "expiryDate": "30/10/2024",
    "name": "Quotation related to Limited Tender Enquiry from empanelled agencies for the following works: 1. Digital Ads & Influencer, 2. Designing, 3. Logistics, 4. Concept (Event), 5. Concepulization, and 6. Event Management for organizing Bihar Women's Asian Hockey Championship Trophy 2024 (Letter No.: 4033)",
    "corrigendum": "",
    "url": ""
  },
  {
    "key": "T8",
    "eventName": "tenders",
    "date": "10/07/2024,",
    "expiryDate": "----",
    "name": "NOTICE RELATED TO SUBMISSION OF TENDER RELATED TO EMPANELMENT OF TRANSPORATION AGENCY(PR No -001689(B & C) 2024 - 25",
    "corrigendum": "",
    "url": "img/tenders/L.No. 2457 dt.10.07.2024.PDF"
  },
  {
    "key": "T8",
    "eventName": "tenders",
    "date": "05/07/2024,",
    "expiryDate": "10/07/2024",
    "name": "Corrigendum 02 related to the tender published for operating the mess (canteen) at Patliputra Sports Complex, Kankarbagh, Patna",
    "corrigendum": "",
    "url": "img/tenders/CORRIGNEDUM_2_RELATED_TO_MESS.PDF"
  },
  {
    "key": "T7",
    "eventName": "tenders",
    "date": "02/07/2024,",
    "expiryDate": "",
    "name": "Corrigendum related to the suggestions and other points received in the pre-bid meeting related to sports kit on 24/06/2024",
    "corrigendum": "",
    "url": "img/tenders/Corrigendum Related to Sports Kit RFP.PDF"
  },
  {
    "key": "T6",
    "eventName": "tenders",
    "date": "02/07/2024,",
    "expiryDate": "",
    "name": "Corrigendum regarding tender for selection of catering agency for Patliputra Sports Complex Hostel",
    "corrigendum": "",
    "url": "img/tenders/Corrigendum 2 related to MESS.PDF"
  },
  {
    "key": "T5",
    "eventName": "tenders",
    "date": "26/06/2024,",
    "expiryDate": "",
    "name": "Corrigendum related to the amount of EMD and TENDER FEE of the tender related to sports kit",
    "corrigendum": "",
    "url": "img/tenders/Corrigendum_related_to_Sports_Ki.PDF"
  },

  {
    "key": "T4",
    "eventName": "tenders",
    "date": "25/06/2024,",
    "expiryDate": "",
    "name": "New date for sports kit tenders for Bihar State Sports Authority",
    "corrigendum": "",
    "url": "img/tenders/NewDateforPrebidl.PDF"
  },
  {
    "key": "T3",
    "eventName": "tenders",
    "date": "24/06/2024,",
    "expiryDate": "08/07/2024",
    "name": "Selection of agency for supply of sports kits for Bihar State Sports Authority for a period of 03 years",
    "corrigendum": "",
    "url": "img/tenders/SPORTSKITFULLPDFFILE.pdf"
  },
  {
    "key": "T2",
    "eventName": "tenders",
    "date": "13/06/2024",
    "expiryDate": "05/07/2024",
    "name": "Tender for selection of catering agency for Patliputra Sports Complex Hostel, Patna for a period of five years",
    "corrigendum": "",
    "url": "img/tenders/MESSRPFFULLDETAILSPDFFILE.pdf"
  },
  {
    "key": "T1",
    "eventName": "tenders",
    "date": "12/06/2024",
    "expiryDate": "21/06/2024",
    "name": "EMPANELMENT OF TRANSPORATION AGENCY FOR BIHAR STATE SPORTS AUTHORITY FOR A PERIOD OF 03 YEARS",
    "corrigendum": "",
    "url": "img/tenders/TRAVEL_AGENCY_RFP_FULL_DETAILS_WORD_FILE.pdf"
  }
  // {
  //     "key": "T10",
  //     "eventName": "tenders",
  //     "date": "_",
  //     "expiryDate": "_",
  //     "name": "Corrigendum related to Travel Agency RFP",
  //     "corrigendum": "",
  //     "url": "img/tenders/Corrigendum_Travel Agency.docx"
  // },
  // {
  //     "key": "T9",
  //     "eventName": "tenders",
  //     "date": "11/01/2024",
  //     "expiryDate": "22/01/2024",
  //     "name": "EMPANELMENT OF TRANSPORATION AGENCY FOR BIHAR STATE SPORTS AUTHORITY FOR A PERIOD OF 03 YEAR",
  //     "corrigendum": "",
  //     "url": "img/tenders/RFP_FOR_Travel_Agency_for_BSSA_PDF_full_details.pdf"
  // },

  // {
  //     "key": "T8",
  //     "eventName": "tenders",
  //     "date": "15/12/2023",
  //     "expiryDate": "_____",
  //     "name": "ESTABLISHMENT OF PROJECT MONITORING UNIT FOR PROMOTING E-SPORTS OF BIHAR FOR A PERIOD OF 03 YEARS",
  //     "corrigendum": "",
  //     "url": "img/tenders/Corrigendum_E-Sports.pdf"
  // },
  // {
  //     "key": "T7",
  //     "eventName": "tenders",
  //     "date": "11/12/2023",
  //     "expiryDate": "18/12/2023",
  //     "name": "Regarding purchasing sports equipment for Center of Excellence",
  //     "corrigendum": "",
  //     "url": "img/tenders/weightliftingcenterofexcellence.pdf"
  // },
  // {
  //     "key": "T6",
  //     "eventName": "tenders",
  //     "date": "06/12/2023",
  //     "expiryDate": "15/12/2023",
  //     "name": "ESTABLISHMENT OF PROJECT MONITORING UNIT FOR PROMOTING E-SPORTS IN THE STATE OF BIHAR FOR A PERIOD OF 03 YEARS",
  //     "corrigendum": "",
  //     "url": "img/tenders/ESTABLISHMENTOFPROJECTMONITORING.pdf"
  // },
  // {
  //     "key": "T1",
  //     "eventName": "tenders",
  //     "date": "21/08/2023",
  //     "expiryDate": "11/09/2023",
  //     "name": "RFP for Selection of catering agency for Patliputra sports complex hostel, Patna for 05 years",
  //     "corrigendum": "",
  //     "url": "img/tenders/RFP for Selection of catering agency for Patliputra sports complex hostel, Patna for 05 years.pdf"
  // },
  // {
  //     "key": "T2",
  //     "eventName": "tenders",
  //     "date": "24/07/2023",
  //     "expiryDate": "24/07/2026",
  //     "name": "Letter No. 1003 Dated 24.07.2023 (4).pdf",
  //     "corrigendum": "",
  //     "url": "img/tenders/letter_number_1003_dated_24072023.pdf"
  // },
  // {
  //     "key": "T3",
  //     "eventName": "tenders",
  //     "date": "24/07/2023",
  //     "expiryDate": "24/07/2026",
  //     "name": "RFP COMPREHENSIVE HOUSEKEEPING, MAINTENANCE AND OPERATION CONTRACT (FOR 03 YEARS) FOR STADIUMS, OFFICES, HOSTELS AND OTHER ALLIED FACILITIES AT BIHAR STATE SPORTS AUTHORITY",
  //     "corrigendum": "",
  //     "url": "img/tenders/133343212303759748.pdf"
  // },
  // {
  //     "key": "T4",
  //     "eventName": "tenders",
  //     "date": "23/06/2023",
  //     "expiryDate": "23/06/2025",
  //     "name": "Corrigendum :(Pre Bid Queries) RFP for design, development, testing, commissioning, integration and maintenance of website at Bihar State Sports Authority (BSSA) for a period of 2 years",
  //     "corrigendum": "",
  //     "url": "img/tenders/TENDER.pdf"
  // },
  // {
  //     "key": "T5",
  //     "eventName": "tenders",
  //     "date": "23/06/2023",
  //     "expiryDate": "23/06/2025",
  //     "name": "Corrigendum :(Pre- bid- quarries) RFP for design, development, testing, commissioning, integration and maintenance of website at Bihar State Sports Authority (BSSA) for a period of 2 years  CamScanner 06-23-2023 13.31.09.pdf",
  //     "corrigendum": "",
  //     "url": "img/tenders/CamScanner 06-23-2023 13.31.09.pdf"
  // }
]